import { render, staticRenderFns } from "./CSFEdit.vue?vue&type=template&id=096ceb0c&"
import script from "./CSFEdit.vue?vue&type=script&lang=js&"
export * from "./CSFEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports